'use strict';

import $ from 'jquery';
import { modalSaveReport } from '../../modules/modalSaveReport';

Dropzone.autoDiscover = false;
import 'dropzone';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    dz_default_message: 'Selecione os arquivos que deseja enviar',
    dz_cancel_upload: 'Cancelar o envio',
    dz_remove_file: 'Remover',
    dz_max_files_exceeded: 'Você já adicionou um arquivo',
    dz_file_too_big: 'Arquivo muito grande',
    dz_invalid_file_type: 'Este arquivo não é uma imagem',
  },
  en: {
    dz_default_message: 'Select the files you want to send',
    dz_cancel_upload: 'Cancel upload',
    dz_remove_file: 'Remove',
    dz_max_files_exceeded: 'You have already added a file',
    dz_file_too_big: 'Very large file',
    dz_invalid_file_type: 'This file is not an image',
  },
  es: {
    dz_default_message: 'Selecciona los archivos que deseas enviar',
    dz_cancel_upload: 'Cancelar el envío',
    dz_remove_file: 'Eliminar',
    dz_max_files_exceeded: 'Ya has añadido un archivo',
    dz_file_too_big: 'Archivo muy grande',
    dz_invalid_file_type: 'Este archivo no es una imagen',
  },
};

const gallery = {
  init() {
    modalSaveReport();

    const _token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const challengeId = document.querySelector('[name="id"]').value;

    new Dropzone('#myDropzone', {
      url: `${window.location.origin}/acoes-disponiveis/${challengeId}/relatorio/upload-fotos`,
      paramName: 'gallery',
      maxFilesize: 10,
      maxFiles: 50,
      acceptedFiles: 'image/*',
      params: {
        _token: _token,
      },
      addRemoveLinks: true,
      dictDefaultMessage: tr[lang].dz_default_message,
      dictCancelUpload: tr[lang].dz_cancel_upload,
      dictRemoveFile: tr[lang].dz_remove_file,
      dictMaxFilesExceeded: tr[lang].dz_max_files_exceeded,
      dictFileTooBig: tr[lang].dz_file_too_big,
      dictInvalidFileType: tr[lang].dz_invalid_file_type,
      init: function () {
        this.on('success', function (file, response) {
          $('.added_photos').append(
            '<input type="hidden" data-name="' + file.name + '" name="gallery[]" value="' + response + '"/>'
          );
        });
        this.on('removedfile', function (file, response) {
          $("input[name='gallery[]']").each(function () {
            if ($(this).attr('data-name') == file.name) {
              $(this).remove();
            }
          });
        });
      },
    });
  },
};

export default gallery;
